
import React, {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';

export function LogoutForm()
{
    const [loggedOut, setLoggedOut] = useState('Logging out...');
    //const [logoutDone, setLogoutDone] = useState(false);
    const navigate = useNavigate();
    let logoutDone = useRef(false);
        useEffect(() => {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },           
            };
            const logOut = async () =>{
                try {
                    logoutDone.current = true;
                    const response = await fetch('https://prcmembership.com:7264/api/Logout/?token=' + sessionStorage.getItem("Token"), requestOptions)
                    
                    if (!response.ok) {
                      throw new Error('Network response was not ok');
                    }
                    const data = await response.json();
                    if(data.succeeded === true)
                    {
                        setLoggedOut("You have successfully logged out");
                    }
                    else
                    {
                        setLoggedOut("You have logged out");
                    }
                    sessionStorage.clear();
        
                  } catch (error) {
                    console.error('Error:', error);
                    navigate("/Login");
                  }
                }
            if(!logoutDone.current)
            {
                
                logOut();
                
            }
        });

    return (
        <div>           
            <div className='renderloggedout' >
                <div>{loggedOut}</div>
                <div style={{"padding":"10px"}}>
                <input type="button" className='prcbtn' value="Login" onClick={()=>{navigate("/Login")}} alt="Login"/>
                </div>
           </div>
        </div>            
    );
}